import React from "react";
import AppConfig from "../../entities/AppConfig";
import { ApplicationUser } from "../../entities/ApplicationUser";
import {AssetWritingLogs} from "../../entities/AssetWritingLogs";
import { BuilderAsset } from "../../entities/BuilderAsset";
import { BuilderPreferences } from "../../entities/BuilderPreferences";
import { BuilderActionLocations } from "../../utilities/Tracking/EventTracking";

export enum BuilderAppBarAction {
	GoBack,
	Present,
	Share,
    SaveAsTemplate
}

export type SelectedContent =
	| { type: "Sermon"; selectedSermonId: string }
	| { type: "Illustration"; selectedIllustrationId: string }
	| { type: "Bible Verse"; selectedScriptureReference: string };

export interface BuilderState {
	builderAsset: BuilderAsset;
	setBuilderAsset: (builderAsset: BuilderAsset) => void;
	preferences: BuilderPreferences;
    savePreferences: (preferences: BuilderPreferences) => void;
    customImageBase64Content?: string;
    setCustomImageBase64Content: (content: string) => void;
    handleAppBarAction: (action: BuilderAppBarAction, location:BuilderActionLocations) => void;
    handleContentDetailSelection: (selectedContent: SelectedContent) => void;
    copyToClipboard: (content: string, type: "Sermon" | "Illustration" | "Verse") => void;
    showShareDialog: (fromSlides: boolean, location:BuilderActionLocations) => void;
    setAlert: (message: string) => void;
    writingLogs: AssetWritingLogs;
    refreshWritingLog: () => void;
    toggleSlideExportDialog: (location:BuilderActionLocations) => void;

    // These should really come from a global context
    appConfig: AppConfig;
    user?: ApplicationUser | null;
}

export const BuilderContext = React.createContext<BuilderState>({} as any);

export function useBuilder() {
	return React.useContext(BuilderContext);
}
